<div class="flex row gap-8 vertical-center" (click)="startChat()">
	<mat-icon [ngClass]="loggedUser && !smallScreen ? 'logged-text-color pointer h5' : 'text-primary-darker pointer h5'"
		[svgIcon]=" loggedUser && !smallScreen? 'support_light' : 'support'"></mat-icon>
	<span [ngClass]="loggedUser && !smallScreen ? 'logged-text-color pointer' : 'text-primary-darker pointer'">{{'general.support' | translateWithKeys}}</span>
</div>
